<template>
  <div :id="questionId" class="questionModel" @clearValue="clearValue()">
    <div>
      <table class="w-100" style="min-width: 130px">
        <tr height="30 px" class="mx-0 text-center align-middle" style="background-color: #f2effb">
          <b-col></b-col>
        </tr>
        <tr
          height="80 px"
          v-for="idx in staticListCount"
          :key="'listAnswer' + idx"
          class="p-0"
          :style="bgc[(idx - 1) % 2]"
        >
          <td class="py-0 align-middle">
            <b-form-input
              :id="questionId + '_value' + '_' + idx"
              type="number"
              :name="name"
              @input="changeItem()"
              :placeholder="placeholder"
              maxlength="255"
              class="form-control rowHeight"
              v-model="rowArray[idx - 1]"
            />
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  export default {
    name: 'StaticNumber',
    props: [
      'placeholder',
      'label',
      'name',
      'validationsType',
      'answer',
      'questionId',
      'staticListCount',
    ],
    data() {
      return {
        rowData: '',
        rowArray: [],
        bgc: ['background-color:#FAFAFA', 'background-color:#F6F4FF'],
      };
    },
    computed: {
      textBoxValueId() {
        return this.answer !== undefined ? this.answer[0]['Id'] : undefined;
      },
    },
    created() {
      this.rowData =
        this.answer !== undefined ? JSON.parse(this.answer[0]['Saved_Value_Long__c']) : '';
      if (this.rowData != '') {
        Object.entries(this.rowData).forEach(
          ([key, value]) => (this.rowArray[`${key}`] = `${value}`),
        );
        this.emitValue();
      } else this.rowArray = [];
    },
    methods: {
      ...mapActions(['dirtySurvey']),
      changeItem() {
        this.dirtySurvey(this.validationsType);
        this.emitValue();
      },
      clearValue() {
        this.rowArray = [];
        this.emitValue();
        this.percentageState = null;
      },
      emitValue() {
        this.$emit('input', {
          value: JSON.stringify(Object.assign({}, this.rowArray)),
          id: this.textBoxValueId,
        });
      },
    },
  };
</script>
